import {GridLocaleText} from "@mui/x-data-grid";

const LocaleText: GridLocaleText = {
    columnMenuAriaLabel: (columnName: string) => `Menu de coluna para ${columnName}`,



    noRowsLabel: 'Nenhum dado disponível.',
    noResultsOverlayLabel: 'Nenhum resultado encontrado.',

    // Density selector toolbar button text
    toolbarDensity: 'Densidade',
    toolbarDensityLabel: 'Densidade',
    toolbarDensityCompact: 'Compacta',
    toolbarDensityStandard: 'Padrão',
    toolbarDensityComfortable: 'Confortável',

    // Columns selector toolbar button text
    toolbarColumns: 'Colunas',
    toolbarColumnsLabel: 'Selecionar colunas',

    // Filters toolbar button text
    toolbarFilters: 'Filtros',
    toolbarFiltersLabel: 'Exibir filtros',
    toolbarFiltersTooltipHide: 'Ocultar filtros',
    toolbarFiltersTooltipShow: 'Exibir filtros',
    toolbarFiltersTooltipActive: (count) =>
        count !== 1 ? `${count} filtros ativos` : `${count} filtro ativo`,

    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: 'Pesquisar...',
    toolbarQuickFilterLabel: 'Pesquisar',
    toolbarQuickFilterDeleteIconLabel: 'Limpar',

    // Export selector toolbar button text
    toolbarExport: 'Exportar',
    toolbarExportLabel: 'Exportar',
    toolbarExportCSV: 'Baixar como CSV',
    toolbarExportPrint: 'Imprimir',
    toolbarExportExcel: 'Baixar como Excel',

    // Columns management text
    columnsManagementSearchTitle: 'Pesquisar',
    columnsManagementNoColumns: 'Nenhuma coluna',
    columnsManagementShowHideAllText: 'Exibir/Ocultar Todas',
    columnsManagementReset: 'Redefinir',
    columnsManagementDeleteIconLabel: 'Limpar',

    // Filter panel text
    filterPanelAddFilter: 'Adicionar filtro',
    filterPanelRemoveAll: 'Remover todos',
    filterPanelDeleteIconLabel: 'Excluir',
    filterPanelLogicOperator: 'Operador lógico',
    filterPanelOperator: 'Operador',
    filterPanelOperatorAnd: 'E',
    filterPanelOperatorOr: 'Ou',
    filterPanelColumns: 'Colunas',
    filterPanelInputLabel: 'Valor',
    filterPanelInputPlaceholder: 'Valor do filtro',

    // Filter operators text
    filterOperatorContains: 'contém',
    filterOperatorDoesNotContain: 'não contém',
    filterOperatorEquals: 'é igual a',
    filterOperatorDoesNotEqual: 'é diferente de',
    filterOperatorStartsWith: 'começa com',
    filterOperatorEndsWith: 'termina com',
    filterOperatorIs: 'é',
    filterOperatorNot: 'não é',
    filterOperatorAfter: 'é após',
    filterOperatorOnOrAfter: 'é em ou após',
    filterOperatorBefore: 'é antes',
    filterOperatorOnOrBefore: 'é em ou antes',
    filterOperatorIsEmpty: 'está vazio',
    filterOperatorIsNotEmpty: 'não está vazio',
    filterOperatorIsAnyOf: 'é qualquer um de',
    'filterOperator=': '=',
    'filterOperator!=': '!=',
    'filterOperator>': '>',
    'filterOperator>=': '>=',
    'filterOperator<': '<',
    'filterOperator<=': '<=',

    // Header filter operators text
    headerFilterOperatorContains: 'Contém',
    headerFilterOperatorDoesNotContain: 'Não contém',
    headerFilterOperatorEquals: 'É igual a',
    headerFilterOperatorDoesNotEqual: 'É diferente de',
    headerFilterOperatorStartsWith: 'Começa com',
    headerFilterOperatorEndsWith: 'Termina com',
    headerFilterOperatorIs: 'É',
    headerFilterOperatorNot: 'Não é',
    headerFilterOperatorAfter: 'É após',
    headerFilterOperatorOnOrAfter: 'É em ou após',
    headerFilterOperatorBefore: 'É antes',
    headerFilterOperatorOnOrBefore: 'É em ou antes',
    headerFilterOperatorIsEmpty: 'Está vazio',
    headerFilterOperatorIsNotEmpty: 'Não está vazio',
    headerFilterOperatorIsAnyOf: 'É qualquer um de',
    'headerFilterOperator=': 'Igual',
    'headerFilterOperator!=': 'Diferente',
    'headerFilterOperator>': 'Maior que',
    'headerFilterOperator>=': 'Maior ou igual a',
    'headerFilterOperator<': 'Menor que',
    'headerFilterOperator<=': 'Menor ou igual a',

    // Filter values text
    filterValueAny: 'qualquer',
    filterValueTrue: 'verdadeiro',
    filterValueFalse: 'falso',

    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuShowColumns: 'Exibir colunas',
    columnMenuManageColumns: 'Gerenciar colunas',
    columnMenuFilter: 'Filtro',
    columnMenuHideColumn: 'Ocultar coluna',
    columnMenuUnsort: 'Desfazer ordenação',
    columnMenuSortAsc: 'Ordenar em ordem crescente',
    columnMenuSortDesc: 'Ordenar em ordem decrescente',

    // Column header text
    columnHeaderFiltersTooltipActive: (count) =>
        count !== 1 ? `${count} filtros ativos` : `${count} filtro ativo`,
    columnHeaderFiltersLabel: 'Exibir filtros',
    columnHeaderSortIconLabel: 'Ordenar',

    // Rows selected footer text
    footerRowSelected: (count) =>
        count !== 1
            ? `${count.toLocaleString()} linhas selecionadas`
            : `${count.toLocaleString()} linha selecionada`,

    // Total row amount footer text
    footerTotalRows: 'Total de linhas:',

    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount) =>
        `${visibleCount.toLocaleString()} de ${totalCount.toLocaleString()}`,

    // Checkbox selection text
    checkboxSelectionHeaderName: 'Seleção por caixa de seleção',
    checkboxSelectionSelectAllRows: 'Selecionar todas as linhas',
    checkboxSelectionUnselectAllRows: 'Desmarcar todas as linhas',
    checkboxSelectionSelectRow: 'Selecionar linha',
    checkboxSelectionUnselectRow: 'Desmarcar linha',

    // Boolean cell text
    booleanCellTrueLabel: 'sim',
    booleanCellFalseLabel: 'não',

    // Actions cell more text
    actionsCellMore: 'mais',

    // Column pinning text
    pinToLeft: 'Fixar à esquerda',
    pinToRight: 'Fixar à direita',
    unpin: 'Desafixar',

    // Tree Data
    treeDataGroupingHeaderName: 'Agrupar',
    treeDataExpand: 'ver filhos',
    treeDataCollapse: 'ocultar filhos',

    // Grouping columns
    groupingColumnHeaderName: 'Agrupar',
    groupColumn: (name) => `Agrupar por ${name}`,
    unGroupColumn: (name) => `Parar de agrupar por ${name}`,

    // Master/detail
    detailPanelToggle: 'Alternar painel de detalhes',
    expandDetailPanel: 'Expandir',
    collapseDetailPanel: 'Recolher',


    // Used core components translation keys
    MuiTablePagination: {
        // component: (props: any) => {
        //     return (
        //         <TablePagination
        //             {...props}
        //             labelRowsPerPage="Linhas por página" // Sobrescreve o label de "Rows per page"
        //             // labelDisplayedRows={({ from, to, count }: any) =>
        //             //     `${from}–${to} de ${count !== -1 ? count : `mais de ${to}`}`
        //             // }
        //         />
        //     );
        // }
    },

    // Row reordering text
    rowReorderingHeaderName: 'Reordenar linhas',

    // Aggregation
    aggregationMenuItemHeader: 'Agregação',
    aggregationFunctionLabelSum: 'soma',
    aggregationFunctionLabelAvg: 'média',
    aggregationFunctionLabelMin: 'mínimo',
    aggregationFunctionLabelMax: 'máximo',
    aggregationFunctionLabelSize: 'tamanho',
};

export default LocaleText;